import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "differentMindset",
  "betterPlan",
  "personalLifeChanges",
  "healthChanges",
  "moreMotivated",
  "other",
] as const

export default function WhatsDifferent() {
  return <MultiSelectPage translationKey="whatsDifferent" options={OPTIONS} />
}
